import vi from 'element-ui/lib/locale/lang/vi';

// 越南语(越南)
export default {
  ...vi,
  layout: {
    title: 'Đăng nhập bằng ID Uniportal',
    tip: 'Số điện thoại chưa đăng ký sẽ được tự động đăng ký sau khi đăng nhập thành công',
    line: 'Tùy chọn đăng nhập khác',
  },
  button: {
    submit: 'Đăng nhập / Đăng ký',
    getCode: 'Lấy mã',
    emailRegister: 'E-posta ile Kaydolma',
    w3Login: 'Đăng nhập tài khoản W3',
    employeeLogin: 'Đăng nhập nhân viên',
    passwordLogin: 'Mật khẩu đăng nhập',
    reSend: 'Gửi lại',
    problem: 'Trợ giúp trực tuyến',
    privacyPolicy: 'Tuyên bố về quyền riêng tư',
  },
  placeholder: {
    phoneNumber: 'Số điện thoại di động',
    verificationCode: 'Mã xác minh qua SMS',
  },
  dialog: {
    imgCode: 'Nhập các ký tự trên hình.',
    userAgreements: {
      header: 'Thỏa thuận Người dùng và Tuyên bố Quyền riêng tư',
      text1: 'Vui lòng đọc và đồng ý với {privacy} và {agreement}.',
      text2:
        'Thông tin cá nhân sẽ được chuyển cho các công ty con ở nước ngoài của Huawei để xử lý khi truy cập các ứng dụng ở nước ngoài của Huawei. Chi tiết có thể xem tại {privacy}',
    },
    crossBorder: {
      header: 'Lời nhắc ủy quyền',
      text: 'Dịch vụ địa phương bạn sử dụng và nơi đăng ký tài khoản của bạn không nằm trong cùng một khu vực.Liên quan đến việc truy cập thông tin tài khoản xuyên biên giới, cần phải có sự cho phép của bạn.',
    },
    multiAccounts: 'Chọn tài khoản.',
    agreeButton: 'Đồng ý và tiếp tục',
    disagreeButton: 'Không đồng ý',
    confirmButton: 'Xác nhận',
    cancelButton: 'Hủy bỏ',
    knowMe: 'OK',
  },
  toast: {
    hasSend: 'Đã gửi mã xác minh.',
    wait: 'Xin chờ một chút',
  },
  tooltip: {
    Huawei: 'ID Huawei',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'Không được để trống mã CAPTCHA.',
    'IDC-03-0002': 'Mã CAPTCHA đã hết hạn.',
    'IDC-00-0004': 'Mã CAPTCHA không đúng.',

    // 表单输入为空
    'IDC-01-00024': 'Cần có mã quốc gia để xác minh số điện thoại di động của bạn.',
    phoneNumberEmpty: 'Nhập số di động.',
    'IDC-03-00033': 'Nhập mã xác minh nhận được qua SMS.',

    // 表单数据错误
    'IDC-02-00227': 'Số điện thoại được nhập không khớp với quốc gia/khu vực đã chọn',
    'IDC-02-00226': 'Mã quốc gia bị cấm',
    'IDC-02-00029': 'Mã xác minh không đúng hoặc đã hết hạn',
    'IDC-02-0013': 'Đăng nhập SMS không thành công, mã xác minh không chính xác',
    'IDC-02-0020': 'Xác minh không thành công. Sai mã xác minh.',
    'IDC-02-00028': 'Số điện thoại di động phải là số có độ dài từ 6 đến 30',
    'IDC-02-00012': 'Số điện thoại sai',

    // 错误操作锁定
    accountLock: 'Số di động hoặc mã xác minh không đúng. Còn {number} lần thử.',
    accountLocked: 'Quá nhiều lần thử không thành công. Vui lòng thử lại sau {number} giây.',
    operationRisk: 'Thao tác hiện tại có nguy cơ bảo mật. Vui lòng thử lại sau {number} giây!',

    // 频繁操作
    'IDC-02-00038': 'Vui lòng thử lại sau 60 giây.',
    'IDC-02-00064': 'Bạn đã gửi mã xác minh quá thường xuyên. Vui lòng thử lại sau 24 giờ!',
    'IDC-02-00211': 'Hoạt động hiện tại có nguy cơ bảo mật, vui lòng thử lại sau!',
    'IDC-02-00212':
      'Số điện thoại của bạn đã gửi mã xác minh quá thường xuyên. Hãy thử thay đổi số điện thoại hoặc thử lại sau 24 giờ!',
    'IDC-02-00213': 'Bạn đã gửi mã xác minh quá thường xuyên. Vui lòng thử lại sau 24 giờ!',
    'IDC-02-00215':
      'Số điện thoại của bạn đã gửi mã xác minh quá thường xuyên. Hãy thử thay đổi số điện thoại, chọn phương pháp xác minh khác hoặc thử lại sau 24 giờ!',
    'IDC-02-00228': 'Bạn đã gửi mã xác minh quá thường xuyên. Vui lòng thử lại sau 1 giờ!',
    'IDC-02-00092': 'Các hoạt động hiện tại là quá thường xuyên. Vui lòng thử lại sau 24 giờ.',

    // 请求异常
    'IDC-10-00400': 'Yêu cầu khách hàng bất thường ',
    'IDC-10-00500': 'Lỗi nội bộ hệ thống ',
    'IDC-02-00264': 'Yêu cầu truy cập trái phép bị cấm',
    'IDC-02-00063': 'Tham số không hợp lệ',
    'IDC-03-0007': 'Hoạt động hiện tại có rủi ro bảo mật, tạm thời không thể đăng ký.', // 机翻
    'IDC-03-00057': 'Hoạt động hiện tại có rủi ro an ninh.',

    // 页面过期
    'IDC-00-00017': 'Trang đã hết hạn.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Trở lại',
  closeButton: 'Đóng',

  // 滑块验证相关：
  resourceReqFailed: 'Yêu cầu tài nguyên thất bại. Refresh lại trang và thử lại.',
  verifyFailedAndPlsRetry: 'Xác thực thất bại, vui lòng thử lại',
  serviceErrAndPlsRetry: 'Dịch vụ ngoại lệ. Vui lòng thử lại.',
  learnMore: 'Tìm hiểu thêm',
  cookieBannerText: 'Trang web này sử dụng chức năng cookie để cung cấp cho bạn trải nghiệm người dùng tốt nhất.',
};
